module.exports = __webpack_public_path__ + "media/images/emblems/Chenens-coat_of_arms-ab3b5b31537f37692648251c5c7bb966.svg";